export default __webpack_public_path__ + "static/media/13.9004d104.jpeg";